/**
 * features/reports/MonthlyBarChart.tsx — กราฟแท่งรายรับ/รายจ่าย 12 เดือน
 *
 * เขียนเป็น SVG เองแทนใช้ chart library เพราะมีกราฟเดียวในทั้งระบบ
 * ไลบรารีอย่าง recharts เพิ่ม bundle ~400KB ซึ่งไม่คุ้มสำหรับกราฟแท่งธรรมดาแบบนี้
 */

import { thaiMonthName } from '@ft/core';
import type { MonthlySeriesPoint } from '~/lib/types';

const HEIGHT = 180;
const BAR_GAP = 6;

export function MonthlyBarChart({ data }: { data: MonthlySeriesPoint[] }) {
  const max = Math.max(1, ...data.flatMap((point) => [point.revenue, point.expense]));

  return (
    <div>
      <div className="flex items-end gap-1" style={{ height: HEIGHT }}>
        {data.map((point) => {
          const revenueHeight = (point.revenue / max) * HEIGHT;
          const expenseHeight = (point.expense / max) * HEIGHT;

          return (
            <div key={point.month} className="flex flex-1 flex-col items-center justify-end gap-0.5">
              <div className="flex h-full w-full items-end justify-center" style={{ gap: BAR_GAP }}>
                <div
                  className="w-full rounded-t-sm bg-accent"
                  style={{ height: Math.max(2, revenueHeight) }}
                  title={`รายรับ: ${point.revenue.toLocaleString('th-TH')} บาท`}
                />
                <div
                  className="w-full rounded-t-sm bg-danger opacity-70"
                  style={{ height: Math.max(2, expenseHeight) }}
                  title={`ค่าใช้จ่าย: ${point.expense.toLocaleString('th-TH')} บาท`}
                />
              </div>
              <span className="mt-1 text-[10px] text-fg-subtle">{thaiMonthName(point.month, 'short')}</span>
            </div>
          );
        })}
      </div>

      <div className="mt-3 flex items-center gap-4 text-xs text-fg-muted">
        <span className="flex items-center gap-1.5">
          <span className="h-2.5 w-2.5 rounded-sm bg-accent" />
          รายรับ
        </span>
        <span className="flex items-center gap-1.5">
          <span className="h-2.5 w-2.5 rounded-sm bg-danger opacity-70" />
          ค่าใช้จ่าย
        </span>
      </div>
    </div>
  );
}
